/**
 * ErrorPage Component - Pagina di errore con props dinamiche
 * Mostra messaggi di errore personalizzati (es. accesso negato)
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/common/Button';
import { HTTP_STATUS } from '../utils/constants';

const ErrorPage = ({
  code = HTTP_STATUS.FORBIDDEN,
  message = 'Accesso negato',
  description,
  showLoginButton = false,
  showHomeButton = true,
}) => {
  const navigate = useNavigate();

  const getErrorIcon = () => {
    if (code >= 400 && code < 500) {
      // Errori client (4xx) - icona warning
      return (
        <svg
          className="w-24 h-24 mx-auto text-yellow-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      );
    }

    // Errori server (5xx) o altri - icona error
    return (
      <svg
        className="w-24 h-24 mx-auto text-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        {/* Icon */}
        <div className="mb-6">{getErrorIcon()}</div>

        {/* Error Code */}
        {code && (
          <p className="text-6xl font-bold text-gray-300 mb-2">{code}</p>
        )}

        {/* Error Message */}
        <h1 className="text-2xl font-bold text-gray-800 mb-3">{message}</h1>

        {/* Description */}
        {description && (
          <p className="text-gray-600 mb-6 whitespace-pre-line">{description}</p>
        )}

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {showHomeButton && (
            <Button variant="primary" onClick={() => navigate('/dashboard')}>
              Torna alla Dashboard
            </Button>
          )}

          {showLoginButton && (
            <Button variant="outline" onClick={() => navigate('/login')}>
              Effettua il login
            </Button>
          )}
        </div>

        {/* Additional help */}
        <p className="mt-6 text-sm text-gray-500">
          Se il problema persiste, contatta l'assistenza:{' '}
          <a
            href="mailto:supportoinformatico@anutel.net"
            className="text-anutel hover:underline"
          >
            supportoinformatico@anutel.net
          </a>
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
